let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cWmsq")).then(() => parcelRequire('44pWs'));